import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import biDirectionalBoxesUtils from './utils/biDirectionalBoxes.utils'



export default class biDirectionalBoxesLevelComponent extends BaseLevel {
    onEnter = () => {
        let result = 0
        const operation = this.props.level.settings.operation
        const firstValue = this.state.quantities.value_1
        const secondValue = this.state.quantities.value_2
        const roundsCount = 2
        let answerNumber = this.state.answerNumber || 1

        switch (operation) {
            case 'double':
                result = firstValue * 2
                break
            case 'half':
                result = firstValue / 2
                break
            case 'more':
                result = firstValue + secondValue
                break
            case 'less':
                result = firstValue - secondValue
                break
            case 'more/less':
                result = answerNumber === 1 ? firstValue - secondValue : firstValue + secondValue
                break
            case 'double/half':
                result = answerNumber === 1 ? firstValue / 2 : firstValue * 2
                break
            case 'odd':

                result = answerNumber === 1 ? firstValue - 1 - firstValue % 2 : firstValue + 1 + firstValue % 2
                break
            case 'even':
                result = answerNumber === 1 ? firstValue - 2 + firstValue % 2 : firstValue + 2 - firstValue % 2
                break
            case 'mlpten':
                result = answerNumber === 1 ? Math.floor((firstValue - 1) / 10) * 10 : Math.ceil((firstValue + 1) / 10) * 10
                break
        }

        if (+this.state.answer === +result) {
            if (operation === 'double' || operation === 'half' || operation === 'more' || operation === 'less') {
                this.setState({ wrongAnswer: false, answer: '?', answerNumber: 1 })
                this.props.onRoundComplete()
                this.generateLevel()
                this.onRoundComplete()
            } else {
                if (answerNumber >= roundsCount) {
                    this.setState({ lastAnswer: null, wrongAnswer: false, answer: '?', answerNumber: 1 })
                    this.props.onRoundComplete()
                    this.generateLevel()
                    this.onRoundComplete()
                } else {
                    this.onRoundComplete()
                    this.setState({ lastAnswer: this.state.answer, wrongAnswer: false, answer: '?', answerNumber: answerNumber + 1 })
                }
            }
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }
    render() {
        const level = this.props.level
        const stage = this.props.stage
        const settings = level.settings
        const quantities = this.state.quantities
        const operation = this.state.operation
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const answerRequired = settings.answer_required || 'answer'
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight
        const answerNumber = this.state.answerNumber || 1
        const lastAnswer = this.state.lastAnswer
        return (

            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answer} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {gameContainerHeight > 0 && biDirectionalBoxesUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer, answerNumber, lastAnswer)}
                </div>
            </BaseLevelLayoutComponent>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/biDirectionalBoxes.levels.js